<template>
  <div class="q-ma-xs q-pa-xs">
    <div v-if="showHome"
         class="row justify-center">
      <q-card class="shadow-4"
              style="background: radial-gradient(circle, #ffffff 0%, #f1f1f1 100%);width:100%;max-width:700px"
              bordered>
        <q-item>
          <q-item-section avatar>
            <q-avatar>
              <img :src="url">
            </q-avatar>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ global.user.name }}</q-item-label>
            <q-item-label caption>
              Agencia: {{ global.user.area }}
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-separator />
        <q-card-section horizontal
                        class="bg-secondary text-primary">
          <q-card-section>
            {{ frase }}
          </q-card-section>
        </q-card-section>
        <q-separator />
        <q-card-actions vertical>
          <q-btn flat
                 to="/Recibos/PendientesHoy"
                 color="primary"
                 icon="receipt_long"
                 label="SITUACIÓN DE RECIBOS">
          </q-btn>
        </q-card-actions>
        <q-separator />
        <q-card-section>

          <q-knob show-value
                  class="text-primary q-ma-md"
                  v-model="rPendientes"
                  size="100px"
                  color="secondary">
            {{ recibos.Pendientes }}
            <q-icon name="check_circle" />
            <q-tooltip>Recibos Pendientes</q-tooltip>
          </q-knob>
          <q-knob show-value
                  class="text-positive q-ma-md"
                  v-model="rGestionOK"
                  size="100px"
                  color="positive">
            {{ recibos.GestionOk }}
            <q-icon name="sentiment_very_satisfied" />
            <q-tooltip>Recibos gestionados en fecha</q-tooltip>
          </q-knob>
          <q-knob show-value
                  class="text-warning q-ma-md"
                  v-model="rGestionNoOK"
                  size="100px"
                  color="warning">
            {{ recibos.GestionNoOk }}
            <q-icon name="mood_bad" />
            <q-tooltip>Recibos con gestión caducada</q-tooltip>
          </q-knob>
          <q-knob show-value
                  class="text-negative q-ma-md"
                  v-model="rNoIniciados"
                  size="100px"
                  color="negative">
            {{ recibos.NoIniciados }}
            <q-icon name="sentiment_very_dissatisfied" />
            <q-tooltip>Recibos No iniciados</q-tooltip>
          </q-knob>
          <q-knob show-value
                  class="text-grey q-ma-md"
                  v-model="rCaducados"
                  size="100px"
                  color="grey">
            {{ recibos.Caducados }}
            <q-icon name="event_busy" />
            <q-tooltip>Recibos caducados</q-tooltip>
          </q-knob>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>
<script setup>
import { ref, inject, onMounted, computed, watch } from "vue"
import { frases } from '../config'
import { useRoute } from "vue-router"
const route = useRoute();
const global = inject("global")
const url = ref()
const showHome = ref(false)
const frase = ref()
const rPendientes = 100;
const rNoIniciados = computed(() => recibos.value.NoIniciados * 100 / recibos.value.Pendientes);
const rGestionOK = computed(() => recibos.value.GestionOk * 100 / recibos.value.Pendientes);
const rGestionNoOK = computed(() => recibos.value.GestionNoOk * 100 / recibos.value.Pendientes);
const rCaducados = computed(() => recibos.value.Caducados * 100 / recibos.value.Pendientes);
const recibos = ref({
  Pendientes: 1,
  NoIniciados: 0,
  GestionOk: 0,
  GestionNoOk: 0,
  Caducados: 0
})
async function init() {
  if (global.user.name !== false) {
    showHome.value = true
    const randomIndex = Math.floor(Math.random() * frases.length);
    url.value = new URL(`../img/${global.user.name}.jpg`, import.meta.url).href
    frase.value = frases[randomIndex]
  } else showHome.value = false
}
onMounted(() => { init() })
watch([route, () => global.user.area], () => { init() });
</script>